import { ShieldAlert, UserX } from 'lucide-react'
import { defaultWorkspaceCode, useOpCo } from '../context/OpCoContext'

// Full-page OpCo access states, rendered by Layout in place of the page:
//   variant="forbidden" - the API answered OPCO_FORBIDDEN for this workspace
//   variant="no-access" - OpCos are on but the user belongs to none yet
export function hasNoOpcoAccess({ enabled, loaded, opcos, isOpcoAdmin }) {
  return Boolean(enabled && loaded && (opcos?.length || 0) === 0 && !isOpcoAdmin)
}

export default function OpCoForbidden({ variant = 'forbidden' }) {
  const { opcos, isOpcoAdmin, workspaceCode, switchTo } = useOpCo()

  if (variant === 'no-access') {
    return (
      <div className="flex min-h-[60vh] items-center justify-center p-6">
        <div className="max-w-md text-center">
          <div className="mx-auto mb-4 flex h-12 w-12 items-center justify-center rounded-full bg-gray-100 dark:bg-gray-800">
            <UserX className="h-6 w-6 text-gray-500 dark:text-gray-400" />
          </div>
          <h1 className="text-lg font-semibold text-gray-900 dark:text-gray-100">No OpCo access yet</h1>
          <p className="mt-2 text-sm text-gray-500 dark:text-gray-400">
            You have not been added to any OpCo. Ask your admin to give you access.
          </p>
        </div>
      </div>
    )
  }

  const target = defaultWorkspaceCode(opcos || [], isOpcoAdmin)
  const canGo = target && target.toLowerCase() !== (workspaceCode || '').toLowerCase()

  return (
    <div className="flex min-h-[60vh] items-center justify-center p-6">
      <div className="max-w-md text-center">
        <div className="mx-auto mb-4 flex h-12 w-12 items-center justify-center rounded-full bg-amber-50 dark:bg-amber-900/30">
          <ShieldAlert className="h-6 w-6 text-amber-600 dark:text-amber-400" />
        </div>
        <h1 className="text-lg font-semibold text-gray-900 dark:text-gray-100">You don't have access to this OpCo</h1>
        <p className="mt-2 text-sm text-gray-500 dark:text-gray-400">
          {workspaceCode ? <>Your account is not a member of <span className="font-medium uppercase">{workspaceCode}</span>. </> : null}
          Go back to your own workspace, or ask your admin for access.
        </p>
        {canGo && (
          <button
            type="button"
            onClick={() => switchTo(target)}
            className="mt-5 inline-flex items-center rounded-lg bg-teal-600 px-4 py-2 text-sm font-medium text-white hover:bg-teal-700 transition-colors"
          >
            Go to my workspace
          </button>
        )}
      </div>
    </div>
  )
}
